// 这个文件模拟后端 API 行为

// 定义基础URL
const BASE_URL = 'https://api.ip008.com/stock';

// 获取数据源设置的辅助函数
function getMarketParam() {
  try {
    const settings = JSON.parse(localStorage.getItem('stockMonitorSettings'));
    return settings && settings.market ? settings.market : 'futu';
  } catch (e) {
    return 'futu'; // 默认使用富途
  }
}

function getSelectedPeriods() {
  try {
    const settings = JSON.parse(localStorage.getItem('stockMonitorSettings'));
    const periods = settings && settings.selectedPeriods ? settings.selectedPeriods : [];
    // 将数组中的所有项用下划线连接成一个字符串返回，如果数组为空则返回空字符串
    return Array.isArray(periods) && periods.length > 0 ? periods.join(',') : '';
  } catch (e) {
    // 默认使用1、5、30、60、d、w，用下划线连接
    return '';
  }
}

// 根据时间尺度获取action参数的辅助函数
function getActionFromScale(scale) {
  const scaleMap = {
    '1': 'indicators_1min',
    '5': 'indicators_5min',
    '30': 'indicators_30min',
    '60': 'indicators_60min',
    'd': 'indicators_day',
    'w': 'indicators_week',
  };
  
  return scaleMap[scale] || 'indicators_1min';
}

// 统一股票代码格式
function uniformStockCode(code) {
  const lowerCode = code.toLowerCase();
  // zs means 指数（自己定义的）
  if (lowerCode.startsWith('sh') || lowerCode.startsWith('sz') || lowerCode.startsWith('hk') || lowerCode.startsWith('zs')) {
    return lowerCode;
  }
    
  // 区分美股、港股、A股和可转债
  // 美股（纯字母或字母开头的字母数字组合，不含市场前缀）
  if (/^[a-zA-Z][a-zA-Z0-9.]*$/.test(code)) {
    // 美股代码通常不需要添加市场前缀
    // 但在新浪接口中可能需要特殊处理，这里暂时直接返回代码
    // return code.toUpperCase();    // 美股用大写
    return '';
  }
  // 港股（5位数字）
  else if (/^\d{5}$/.test(code)) {
    return 'hk' + code;
  }
  else if (/^\d{6}$/.test(code)) {
    // 沪市股票（60、68、69开头）
    if (code.startsWith('60') || code.startsWith('68') || code.startsWith('69')) {
      return 'sh' + code;
    }
    // 沪市可转债（11开头）
    else if (code.startsWith('11')) {
      return 'sh' + code;
    }
    // 沪市ETF（51、50、58开头）
    else if (code.startsWith('51') || code.startsWith('50') || code.startsWith('58')) {
      return 'sh' + code;
    }
    // 深市股票（00、30开头）
    else if (code.startsWith('00') || code.startsWith('30')) {
      return 'sz' + code;
    }
    // 深市可转债（12、13开头）
    else if (code.startsWith('12') || code.startsWith('13')) {
      return 'sz' + code;
    }
    // 深市ETF（15、16、39开头）
    else if (code.startsWith('15') || code.startsWith('16') || code.startsWith('39')) {
      return 'sz' + code;
    }
    // 默认处理（根据第一位数字判断）
    else {
      if (code.startsWith('6')) {
        return 'sh' + code;
      } else {
        return 'sz' + code;
      }
    }
  }
  return '';
}

// 导出辅助函数和主对象
const mockApi = {
  /**
   * 模拟发送验证码的 API
   * @param {string} md5Hash - 前端计算的 MD5 哈希值
   * @returns {Promise<object>}
   */
  sendVerificationCode(md5Hash) {
    // console.log(`[Mock API] 接收到 MD5: ${md5Hash}，正在模拟发送验证码...`);
    // 在真实应用中，后端会验证这个 hash 并通过短信服务商发送验证码
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ success: true, message: '验证码已发送' });
      }, 500);
    });
  },
  async getMultiStockData(stockCodes) {
    try {
      // 获取数据源设置
      const market = getMarketParam();
      const periods = getSelectedPeriods();
      
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/stock.php?stockCode=${stockCodes}&action=multi_stock_data2&market=${market}&periods=${periods}`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error('获取多股票数据失败:', error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  /**
   * 获取技术指标数据的 API
   * @param {string} stockCode - 股票代码
   * @param {number} scale - 时间尺度 (1F/5F/30F)
   * @returns {Promise<object>}
   */
  async getIndicatorsData(stockCode, scale = '5') {
    // if (!stockCode.startsWith('sh') && !stockCode.startsWith('sz')) {
    //   return {
    //     success: false,
    //     error: '股票代码必须以sh或sz开头'
    //   };
    // }

    // 根据时间尺度获取action参数
    const action = getActionFromScale(scale);
    // console.log("mock api: scale=", scale, "action=", action);

    try {
      // 获取数据源设置
      const market = getMarketParam();
      
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/stock.php?stockCode=${stockCode}&action=${action}&market=${market}`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取${scale}分钟技术指标数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  async getMultiIndicatorsData(stockCodes, scale = '5') {
    try {
      // 获取数据源设置
      const market = getMarketParam();
      
      // 根据时间尺度获取action参数
      const action = getActionFromScale(scale);
      
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/stock.php?stockCodes=${stockCodes}&action=${action}&market=${market}`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取${scale}分钟多股票技术指标数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  async getStockHealthCheck(stockCode, market, type) {
    try {
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/stock.php?stockCode=${stockCode}&action=check_health&market=${market}&type=${type}&version=2`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取${stockCode}股票健康状态数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  async getHolders(stockCode) {
    try {
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/query.php?stockCode=${stockCode}&action=get_holders`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取${stockCode}股票持有者数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  async getPlates() {
    try {
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/query.php?action=get_plates`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取板块数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  async getPlateStocksScore(plate_id) {
    try {
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/query.php?action=get_plate_stocks_score&plate_id=${plate_id}`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取${plate_id}板块股票评分数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },
  async getMultipleStocksScore(stockCodes) {
    try {
      // 直接调用后端PHP接口，使用参数形式
      const response = await fetch(`${BASE_URL}/query.php?action=get_multiple_stocks_score&stockCodes=${stockCodes}`);
      const result = await response.json();
      
      return result;
    } catch (error) {
      console.error(`获取${stockCodes}多股票评分数据失败:`, error);
      // 返回一个标准的错误格式，而不是抛出异常
      return {
        success: false,
        error: error.message
      };
    }
  },

  /**
   * 上报报警事件的 API
   * @param {Array<object>} alerts - 需要上报的报警事件数组
   * @returns {Promise<object>}
   */
  async postAlerts(alerts) {
    // console.log('[API] 接收到以下报警事件并准备上报:', alerts);
    
    // 遍历alerts数组，将每个item转换成特定格式的字符串
    const alertStrings = alerts.map(alert => {
      // 如果alert对象中没有name字段，我们可以使用code作为name的默认值
      const name = alert.name || alert.code || '未知股票';
      const code = alert.code || '未知代码';
      const event = alert.event || '未知事件';
      const time = alert.time || new Date().toLocaleTimeString('zh-CN');
      
      // 确保中文字符被正确处理
      return `${name}(${code}) ${event}, ${time}`;
    });
    
    // 构造指定格式的JSON数据
    const postData = {
      alerts: alertStrings,
      phone: localStorage.getItem('phone')
    };
    
    try {
      // 使用encodeURIComponent确保中文字符被正确编码
      const jsonString = JSON.stringify(postData);
      
      const response = await fetch(`${BASE_URL}/warning.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body: jsonString
      });
      
      const result = await response.json();
      // console.log('[API] 报警事件上报结果:', result);
      
      return result;
    } catch (error) {
      // console.error('[API] 报警事件上报失败:', error);
      return {
        success: false,
        message: '报警事件上报失败: ' + error.message
      };
    }
  }
};

// 使用 CommonJS 方式导出
module.exports = mockApi;
module.exports.getMarketParam = getMarketParam;
module.exports.getActionFromScale = getActionFromScale;
module.exports.uniformStockCode = uniformStockCode;

// 同时支持 ES6 模块系统的默认导出和命名导出
mockApi.getMarketParam = getMarketParam;
mockApi.getActionFromScale = getActionFromScale;
mockApi.uniformStockCode = uniformStockCode;
